import { useOfflineSync } from "@/hooks/useOfflineSync";

export function SyncStatusBanner() {
  const { status, pendingCount, failedCount, retry } = useOfflineSync();

  if (status === "idle" && pendingCount === 0 && failedCount === 0) {
    return null;
  }

  const message =
    status === "offline"
      ? pendingCount > 0
        ? `Offline — ${pendingCount} item${pendingCount === 1 ? "" : "s"} will sync when you're back online.`
        : "Offline."
      : status === "syncing"
      ? "Syncing…"
      : failedCount > 0
      ? `${failedCount} item${failedCount === 1 ? "" : "s"} couldn't sync — review and retry.`
      : `${pendingCount} item${pendingCount === 1 ? "" : "s"} pending sync…`;

  return (
    <div className="card p-3 mb-4 border-accent/50 bg-accent/10 flex items-center justify-between gap-3">
      <p className="text-text-primary text-xs font-medium">{message}</p>
      {status !== "syncing" && status !== "offline" && (
        <button onClick={() => void retry()} className="text-accent text-xs font-semibold shrink-0">
          Retry
        </button>
      )}
    </div>
  );
}
